import { COLORS } from '../../../../../shared/config/colors/colors';
import { styled } from 'goober';

export const ModalFooter = styled('div')`
    display: flex;
    width: 100%;
    gap: 12px;
    justify-content: flex-end;
`;

export const ModalBody = styled('div')`
    display: flex;
    gap: 20px;
    flex-direction: column;
`;

export const ListBenefits = styled('ul')`
    display: flex;
    gap: 16px;
    flex-direction: column;
`;

export const BenefitItem = styled('li')`
    display: flex;
    gap: 12px;
    align-items: flex-start;
`;

export const BenefitIconWrapper = styled('div')`
    display: flex;
    width: 40px;
    height: 40px;
    border-radius: 12px;
    flex-shrink: 0;
    background: ${COLORS.primary_10};
    color: ${COLORS.primary_60};
    align-items: center;
    justify-content: center;
`;
